import { StyleSheet } from '@react-pdf/renderer';
import { QrPdfTemplatePlatformStyles } from '../config/qr-pdf-template-platform-styles.types';

export const createQRPDFTemplateStyles = (platformStyles: QrPdfTemplatePlatformStyles) =>
  StyleSheet.create({
    page: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: platformStyles.pageBackground,
      padding: 20,
      justifyContent: 'space-between',
    },
    header: {
      display: 'flex',
      alignItems: 'flex-end',
    },
    footer: {
      display: 'flex',
      alignItems: 'flex-start',
    },
    logo: {
      width: 70,
      height: 'auto',
    },
    footerLogo: {
      ...(platformStyles.footerLogoHeight && { height: platformStyles.footerLogoHeight }),
      ...(platformStyles.footerLogoWidth && { width: platformStyles.footerLogoWidth }),
    },
    qrImage: {
      width: 230,
      height: 230,
    },
    shiftNameText: {
      textAlign: 'center',
      fontFamily: 'Urbanist',
      fontSize: 30,
      fontWeight: 700,
      marginBottom: 12,
      color: platformStyles.text,
    },
    shiftDetailText: {
      fontFamily: 'Urbanist',
      fontSize: 16,
      fontWeight: 600,
      color: platformStyles.text,
    },
    shiftDetailContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      alignItems: 'center',
      marginBottom: 40,
    },
    qrCodeContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: 20,
      marginBottom: 20,
    },
    qrCodeBg: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 20,
      borderRadius: 20,
      backgroundColor: platformStyles.qrBackground,
      ...(platformStyles.qrBorder ? { border: `1px solid ${platformStyles.qrBorder}` } : {}),
    },
    infoTextContainer: {
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
    },
    infoText: {
      fontFamily: 'Inter',
      fontSize: 14,
      fontWeight: 300,
      color: platformStyles.text,
      marginBottom: 8,
    },
  });
